module.exports = __webpack_public_path__ + "img/LANG_SETTING.8404694d.svg";